module.exports = __webpack_public_path__ + "img/风电概览.7bad4081.png";